import api from "./api";

export const getInventoryBeginningByWarehouseId = async (Dto: {
    warhouseId: number;
    q?: string;
    limit?: number;
    offset?: number;
    categoryId?: number | null;
}) => {
    // Construct the query string
    const queryParams: Record<string, string> = {};

    if (Dto.q) {
        queryParams.q = Dto.q;
    }

    if (Dto.limit) {
        queryParams.limit = Dto.limit.toString();
    }

    if (Dto.offset) {
        queryParams.offset = Dto.offset.toString();
    }

    if (Dto.categoryId) {
        queryParams.categoryId = Dto.categoryId.toString();
    }

    const queryString = Object.keys(queryParams)
        .map(key => `${key}=${queryParams[key]}`)
        .join('&');

    // Construct the API request URL with the query string
    const url = `/inventories/beginning/${Dto.warhouseId}${queryString ? `?${queryString}` : ''}`;

    return await api.get(url);
};


export const editInventoryBeginning = async (Dto: {
    warehouseId: number;
    id: number;
    editedCost: number | null;
    editedQuantity?: number | null;
    editedSale: number | null;
}) => {
    const url = `/inventories/beginning/item/${Dto.id}/warehouse/${Dto.warehouseId}`

    const payload = {
        itemId: Dto.id,
        warehouseId: Dto.warehouseId,
        quantity: Dto.editedQuantity,
        cost: Dto.editedCost,
        sales: Dto.editedSale
    };

    return await api.put(url, payload);
};

export const deleteItemInventoryBeginningItem = async (Dto: {
    id: number | undefined;
    warehouseId: number;
}) => {
    const url = `/inventories/beginning/delete`;
    return await api.post(url, {
        warehouseId: Dto.warehouseId,
        itemId: Dto.id
    });
};
